module.exports = __webpack_public_path__ + "img/piracy.dc61c097.png";